module.exports = __webpack_public_path__ + "img/coffee.4c95fc49.webp";